import { render, staticRenderFns } from "./acuIcon.vue?vue&type=template&id=49895d80&scoped=true&"
var script = {}
import style0 from "./acuIcon.vue?vue&type=style&index=0&id=49895d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49895d80",
  null
  
)

export default component.exports